import common from './common';
import Module from './module';
import Util, { ViewPort } from './lib/util';
import Mustache from 'mustache';
import Chart from 'chart.js';
import $ from 'jquery';
import 'slick-carousel';
import 'modaal/dist/js/modaal.min.js';

class Components extends Module {

	constructor(options) {
		super(options);

		this.templates = {};

		this.profileLocation = {
			row: 0,
			count: 0,
			position: ''
		};

		this.sliderContent = $('.nha-tab-slider .nha-tab-slider-content');
		this.sliderTabs = $('.nha-tab-slider .nha-tabs');
		this.imageVideoContent = $('.nha-image-video-slider .nha-image-video-slider-content');
		this.featuredItemContent = $('.nha-featured-item-slider .nha-featured-item-slider-content');

		this.windowWidth = window.innerWidth;
	}

	init() {
		return super.init()
			.then(e => {
				let requests = [];

				requests.push(this.getPlayButtonTemplate());

				Promise.all(requests).then(() => this.emit('init'));
			});
	}

	main() {
		this.tabSlider();
		this.imageVideoSlider();
		this.featuredItemSlider();
		this.appendPlayBtn();

		// Give the page time to load, then preload the templates
		window.setTimeout(() => this.preloadTemplates(), 1000);

		Util.equalHeight('.nha-badge');

		if (this.windowWidth >= 1074) {
			Util.equalHeight('.slick-slide .js-activity-equal-height');
		}

		if (Util.checkWidth() === ViewPort.Desktop) {
			// Using parent row container-based equal height for copy-illustration components
			Util.equalHeightByRow('.nha-copy-illustration .nha-gr-12');
			Util.equalHeight('.nha-callout-item');
			Util.equalHeight('.nha-row:not(.nha-pinterest-grid) .nha-basic-card');
			Util.equalHeightAll('.nha-js-card');

			// run again in case content isn't loaded yet
			window.setTimeout(() => Util.equalHeight('.nha-copy-illustration .nha-copy-illustration-js'), 2000);
		}

		if (Util.checkWidth() === ViewPort.Tablet) {
			Util.equalHeight('.nha-event-card');
		}

		if (Util.checkWidth() !== ViewPort.Mobile) {
			Util.equalHeight('.nha-profile-card');
			Util.equalHeight('.nha-nearby-schools-component .nha-location-card');
			Util.equalHeight('.nha-profile-tile');
			Util.equalHeight('.nha-fact');
			Util.equalHeight('.nha-picture-copy-tile');
			// Using parent row container-based equal height for illustration copy tiles
			Util.equalHeightByRow('.nha-illustration-copy-tile');
		}

		this.profileModal();
	}

	bindEvents() {
		$('.profile-expand').on('click', e => this.profileExpanded(e));
		$(window).on('click', e => this.closeProfileExpanded());

		$('.nha-basic-card-toggle').on('click', e => this.basicCardToggle(e));

		$('.nha-activities-container').on('click', '.js-slide-toggle', e => this.tabSliderToggle(e));
		$('.js-navigate-tab').on('keydown', e => this.tabSliderNavigateSlide(e));

		let setVisibleCircle = false;
		let setVisiblePie = false

		// animate graphs on scroll
		$(window).on('scroll resize', e => {
			if (Util.checkIfInView('.nha-circle', '.nha-container') && !setVisibleCircle) {
				setVisibleCircle = true;
				setTimeout(() => {
					this.circleCharts();
				}, 200);
			}	

			if (Util.checkIfInView('.nha-pie-chart-graph', '.nha-container') && !setVisiblePie) {
				setVisiblePie = true;
				setTimeout(() => {
					this.pieChart();
				}, 300);
			}
		});


		let _this = this;
		// on rotate, resize tab slider
		window.addEventListener('orientationchange', function() {
			if (_this.sliderContent.length) {
				setTimeout(() => {
					let slideHeight = _this.sliderContent.find('.slick-current').height();
					_this.sliderContent.find('.slick-list').height(slideHeight);
				}, 1000);	
			}
		}, false);


		//$(window).trigger('scroll');

		// school finder filters
		$('.nha-school-finder-component .nha-school-finder-filter-state select').on('change', Util.debounce(e => this.redirectToSchoolFinder({ state: e.currentTarget.value })));
		$('.nha-school-finder-component .nha-school-finder-filter-zip input.nha-form-control, .nha-school-finder-bar .nha-school-finder-filter-zip input.nha-form-control').on('keypress', Util.debounce(e => {
			if(e.which == 13) {
				this.redirectToSchoolFinder({ zipcode: e.currentTarget.value });
			}
		}));
		$('.nha-school-finder-component .nha-school-finder-filter-zip .nha-btn, .nha-school-finder-bar .nha-school-finder-filter-zip .nha-btn').on('click', Util.debounce(e => this.redirectToSchoolFinder({ zipcode: $('.nha-school-finder-filter-zip .nha-form-control').val() })));

		$(window).on('resize', Util.debounce(e => this.onResize(e)));
	}

	/**
	 * Called when the window is resized (after being debounced)
	 * 
	 * @param {ResizeEvent} e 
	 * @memberof SchoolHome
	 */
	onResize(e) {
		this.resizeProfileExpanded();

		if (this.sliderContent.length) {
			setTimeout(() => {
				let slideHeight = this.sliderContent.find('.slick-current').height();
				this.sliderContent.find('.slick-list').height(slideHeight);
			}, 200);	
		}

		Util.equalHeight('.nha-badge');

		if (Util.checkWidth() === ViewPort.Mobile) {
			$('.nha-event-card').removeAttr('style');
		}

		if (this.windowWidth >= 1074) {
			Util.equalHeight('.slick-slide .js-activity-equal-height');
		}
		else {
			$('.slick-slide .js-activity-equal-height').removeAttr('style');
		}

		if (Util.checkWidth() === ViewPort.Desktop) {
			// Using parent row container-based equal height for copy-illustration components
			Util.equalHeightByRow('.nha-copy-illustration .nha-gr-12');
			$('.nha-basic-card-content').removeAttr('style');
			Util.equalHeight('.nha-row:not(.nha-pinterest-grid) .nha-basic-card');
			Util.equalHeight('.nha-callout-item');
			Util.equalHeightAll('.nha-js-card');
		}
		else {
			$('.nha-copy-illustration .nha-gr-12').removeAttr('style');
			$('.nha-callout-item').removeAttr('style');
			$('.nha-blog-card').removeAttr('style');
            $('.nha-basic-card').removeAttr('style');
            // Removing to fix orientation changes for viewing basic cards
			//$('.nha-basic-card-toggle').removeClass('js-open');
		}

		if (Util.checkWidth() === ViewPort.Tablet) {
			Util.equalHeight('.nha-event-card');
		}

		if (Util.checkWidth() !== ViewPort.Mobile) {
			Util.equalHeight('.nha-profile-card');
			Util.equalHeight('.nha-nearby-schools-component .nha-location-card');
			Util.equalHeight('.nha-profile-tile');
			Util.equalHeight('.nha-fact');
			Util.equalHeight('.nha-picture-copy-tile');
			// Using parent row container-based equal height for illustration copy tiles
			Util.equalHeightByRow('.nha-illustration-copy-tile');
		}
		else {
			$('.nha-profile-card').removeAttr('style');
			$('.nha-nearby-schools-component .nha-location-card').removeAttr('style');
			$('.nha-profile-tile').removeAttr('style');
			$('.nha-fact').removeAttr('style');
			$('.nha-picture-copy-tile').removeAttr('style');
			// Reset heights for row-based equal height recalculation
			$('.nha-illustration-copy-tile').removeAttr('style');
		}
	}

	basicCardToggle(e) {
		var target = $(e.currentTarget);

		target.toggleClass('js-open');
		$(target).prev().slideToggle();
	}

	circleCharts() {

		var circleCounters = circleCounters || [];

		function GetCircleColor(groupID) {
			var count = circleCounters[groupID] || 0;
			count++

			circleCounters[groupID] = count;


			switch (count) {
				case 1:
					return '#00539f';

				case 2:
					return '#77b800';

				case 3:
					return '#fe6410';

				case 4:
					return '#5f6a72';

				default:
					return '#00539f';
			}
		}

		let circles = [];

		$('.nha-circle').each(function (index) {
			// get circle info
			let target = $(this);
			let id = $(target).attr('id');
			let percentage = $(target).data('percentage');
			let label = $(target).data('label');
			let nodeParent = $(target).data('nodeParent');

			let circle = Circles.create({
				id: id,
				radius: getRadius(),
				value: percentage,
				maxValue: 100,
				width: 15,
				colors: ['#b7bec3', GetCircleColor(nodeParent)],
				text: function (value) {
					return '<div class="nha-circle-chart-text-wrap"><h3>' + percentage + '<span class="nha-symbol">%</span></h3><p>' + label + "</p></div>";
				},
				duration: 400,
				wrpClass: 'nha-circle-chart',
				textClass: 'nha-circle-chart-text',
				valueStrokeClass: 'nha-circle-chart-valueStroke',
				maxValueStrokeClass: 'nha-circle-chart-maxValueStroke',
				styleWrapper: true,
				styleText: true
			});

			circles.push(circle);

			$(window).on('resize', e => {
				for (var i = 0; i < circles.length; i++) {
					circles[i].updateRadius(getRadius());
				}
			});

			function getRadius() {
				if (Util.checkWidth() == ViewPort.Desktop) {
					return 98;
				}
				else {
					return 70;
				}
			}
		});
	}

	getProfileExpandedTemplate() {
		return new Promise((resolve, reject) => {
			if (!Util.hasValue(this.templates.profileExpanded)) {
				return $.get(`/${common.getCultureCode()}/template/profile-expanded`, result => {
					if (!result.IsSuccess) return reject(result.Message);

					this.templates.profileExpanded = result.Data;
					Mustache.parse(this.templates.profileExpanded);
					resolve(this.templates.profileExpanded)
				}).catch(reject)
			} else {
				resolve(this.templates.profileExpanded);
			}
		})
	}

	getProfileModalTemplate() {
		return new Promise((resolve, reject) => {
			if (!Util.hasValue(this.templates.profileModal)) {
				return $.get(`/${common.getCultureCode()}/template/profile-modal`, result => {
					if (!result.IsSuccess) return reject(result.Message);

					this.templates.profileModal = result.Data;
					Mustache.parse(this.templates.profileModal);

					resolve(this.templates.profileModal)
				}).catch(reject)
			} else {
				resolve(this.templates.profileModal);
			}
		})
	}

	pieChart() {
		$('.nha-pie-chart-graph').each(function (index) {
			// get circle info
			let target = $(this);
			let id = $(target).data('id');

			var ctx = document.getElementById(id).getContext('2d');

			let data = {
				datasets: [{
					data: [],
					backgroundColor: [
						"rgb(0, 83, 159)",
						"rgb(119, 184, 0)",
						"rgb(254, 100, 16)",
						"rgb(183, 190, 195)",
						"rgb(230, 158, 36)"
					],
				}],
				labels: []
			};

			target.find('span').each(function (index) {
				data.datasets[0].data.push(parseInt($(this).data('item')));
				data.labels.push($(this).data('label'));
			});

			var myPieChart = new Chart(ctx, {
				type: 'pie',
				data: data,
				options: {
					responsive: true,
					legend: {
						display: false
					}
				}
			});
		});
	}

	preloadTemplates() {
		let requests = [];

		requests.push(Util.requestIdleCallback(() => this.getProfileExpandedTemplate()));
		requests.push(Util.requestIdleCallback(() => this.getProfileModalTemplate()));

		return Promise.all(requests);
	}

	profileModal() {
		let getHtml = Promise.resolve(null);

		$('.modal-profile').modaal({
			type: 'inline',
			width: 725,
			custom_class: 'nha-profile-modal',
			background_scroll: false,
			before_open: event => {
				if (Util.checkWidth() !== ViewPort.Desktop) {
					$('body').css('position', 'fixed');
				}
				else {
					$('body').css('overflow', 'hidden');
				}

				let target = $(event.currentTarget);
				let id = $(target).data('id');

				getHtml = new Promise((resolve, reject) => {
					this.getProfileModalTemplate()
						.then(template => resolve(Mustache.render(template, window[`author_${id}`])))
						.catch(reject);
				});
			},
			after_open: modal_wrapper => {
				$('.modaal-close').css('display', 'none');

				// Render template for profile array
				getHtml.then(html => {
					$(modal_wrapper).find('.modaal-content-container').append(html)

					var imgAttr = $(modal_wrapper).find('img').attr('src');

					if (imgAttr == '') {
						$(modal_wrapper).find('img').remove();
					}

					$('.modaal-close').css('display', 'block');
				});
			},
			before_close: modal_wrapper => {
				$('.modaal-close').css('display', 'none');
				$(modal_wrapper).find('.modaal-content-container').empty();
			},
			after_close: e => {
				$('body').removeAttr('style');
			}
		});

		$(window).bind('orientationchange', function (event) {
			if ($('.modaal-wrapper').length) {
				$('.modal-inline').modaal('close');
			}
		});
	}

	/**
	 * Base profile expanded method
	 * Called on click of a profile card
	 * 
	 * @memberof Components
	 */
	profileExpanded(e) {
		e.preventDefault();
		e.stopPropagation();

		// get unique id
		let target = $(e.currentTarget);
		let id = $(target).data('id');
		let grid = 12 / $(target).parent().data('grid');

		let $currentExpanded = $('.nha-profile-card-expanded');

		// if the profile id is different from the current open expanded profile id,
		// close the current one, then open the new one
		if ($('.nha-profile-card-expanded').data('id') != id) {

			$currentExpanded.remove();

			// get child position
			let index = $(target).parent().index();
			let profiles = $(target).closest('.nha-row').find('.nha-gr-12');

			if (Util.checkWidth() !== ViewPort.Desktop) {
				this.profileLocation.count = index + 1;
			} 
			else {
				this.desktopProfileLocation(index, profiles.length, grid);
			}

			this.getProfileExpandedTemplate().then(template => {
				let html = Mustache.render(this.templates.profileExpanded, window["author_" + id]);
				$(target).closest('.nha-row').find('.nha-gr-12:nth-child(' + this.profileLocation.count + ')').after(html);

				$('.nha-profile-card-expanded')	
					.data('id', id)
					.data('index', index)
					.css('display', 'none')
					.slideDown('slow', e => {
						// rebind to on click
						$('.nha-profile-card-expanded').on('click', e => e.stopPropagation());
					});

				$('.nha-profile-card-expanded-arrow').css('left', $(target).position().left + ($(target).find('.nha-profile-card').width() / 2));
			})
		} else {
			// if the current expanded profile is the profile
			// that was clicked on, just close it
			this.closeProfileExpanded();
		}
	}

	/**
	 * Closes expanded profile card when clicking on the window
	 * 
	 * @memberof Components
	 */
	closeProfileExpanded() {
		// Clear current profile
		$('.nha-profile-card-expanded').slideUp('slow', e => {
			$('.nha-profile-card-expanded').remove();
		});
	}

	redirectToSchoolFinder(e) {
		const url = `/${common.getCultureCode()}/school-finder?`;

		const state = Util.trim(e.state);
		const zipcode = Util.trim(e.zipcode);

		if (Util.hasValue(zipcode)) {
			window.location.href = url + `zipcode=${zipcode}`;
		} else if (Util.hasValue(state)) {
			window.location.href = url + `state=${state}`;
		}
	}


	/**
	 * Calculating the profile's row, count, and position
	 * based on the index and total number of profiles
	 * 
	 * @memberof Components
	 */
	desktopProfileLocation(index, totalLength, grid) {
		this.profileLocation.row = Math.ceil((index + 1) / grid);
		this.profileLocation.count = this.profileLocation.row * grid;

		// if the total number of profiles is less than the max row count, use profile length
		if (this.profileLocation.count > totalLength) {
			this.profileLocation.count = totalLength;
		}
	}

	/**
	 * On browser resize, recalculate the position of the expanded profile
	 * if the viewport has changed from desktop to mobile and vise versa.
	 * 
	 * @memberof Components
	 */
	resizeProfileExpanded() {
		let $profileExpanded = $('.nha-profile-card-expanded');
		if ($profileExpanded.length > 0) {
			let $row = $profileExpanded.closest('.nha-row');

			// get data info from current expanded profile
			let id = $profileExpanded.data('id');
			let index = $profileExpanded.data('index');
			let selectedProfile = $row.find('.nha-gr-12:nth-child(' + (index + 1) + ')');
			let grid = 12 / selectedProfile.data('grid');

			// if we're on mobile and the viewport is set to desktop
			if (Util.checkWidth() !== ViewPort.Desktop) {
				$profileExpanded.remove();

				// insert the expanded profile right after the matching index profile
				selectedProfile.after($profileExpanded);

				// update data attributes on expanded profile
				$('.nha-profile-card-expanded')
					.data('id', id)
					.data('index', index)

				// rebind to on click
				$('.nha-profile-card-expanded').on('click', e => e.stopPropagation());
				$('.nha-profile-card-expanded-arrow').css('left', selectedProfile.position().left + (selectedProfile.find('.nha-profile-card').width() / 2));
			}
			else if (Util.checkWidth() === ViewPort.Desktop) {
				$profileExpanded.remove();

				// get the profile position for desktop and insert the expanded profile
				let profiles = $row.find('.nha-gr-12');
				this.desktopProfileLocation(index, profiles.length, grid);
				$row.find('.nha-gr-12:nth-child(' + this.profileLocation.count + ')').after($profileExpanded);

				// update data attributes on expanded profile
				$('.nha-profile-card-expanded')
					.data('id', id)
					.data('index', index);

				// rebind to on click
				$('.nha-profile-card-expanded').on('click', e => e.stopPropagation());
				$('.nha-profile-card-expanded-arrow').css('left', selectedProfile.position().left + (selectedProfile.find('.nha-profile-card').width() / 2));
			
			}
		}
	}

	tabSlider() {
		this.sliderContent.each((i, element) => {
			const content = element.dataset.content;

			$(element).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 200,
				arrows: false,
				dots: false,
				accessibility: true,
				adaptiveHeight: true,
				asNavFor: '.nha-tab-slider .nha-tabs',
				responsive: [
					{
						breakpoint: 1074,
						settings: {
							arrows: true
						}
					}
				],
				nextArrow: `<button class="slick-next slick-arrow slick-focus" aria-label="Next - ${content}" type="button" style="">Next</button>`,
				prevArrow: `<button class="slick-prev slick-arrow slick-focus" aria-label="Previous - ${content}" type="button" style="">Prev</button>`
			});
		});

		this.sliderTabs.slick({
			slidesToShow: 5,
			speed: 200,
			//centerMode: true,
			slidesToScroll: 1,
			variableWidth: true,
			asNavFor: '.nha-tab-slider .nha-tab-slider-content',
			dots: false,
			accessibility: true,
			arrows: false,
			focusOnSelect: true
		});
	}

	tabSliderNavigateSlide(e) {
		if (e.keyCode === 13) {
			let target = $(e.currentTarget);
			let index = $(target).closest('.slick-slide').data('slick-index');

			this.sliderContent.slick('slickGoTo', index);
		}
	}

	tabSliderToggle(e) {
		let target = $(e.currentTarget);
		let toggleContent = $(target).prev();

		if (!target.disabled) {
			target.toggleClass('active');
			target.attr('disabled', 'disabled');
			toggleContent.toggleClass('active');

			let currentHeight = this.sliderContent.find('.slick-current').height();

			if (toggleContent.hasClass('active')) {
				toggleContent.css('visibility', 'hidden').css('display', 'block');
				let hiddenContentHeight = toggleContent.height();
				toggleContent.removeAttr('style');
				toggleContent.css('display', 'none');
				this.sliderContent.find('.slick-list').height(currentHeight + hiddenContentHeight);
			}
			else {
				let hiddenContentHeight = toggleContent.height();
				this.sliderContent.find('.slick-list').height(currentHeight - hiddenContentHeight);
			}

			toggleContent.slideToggle( '400', e => {
				setTimeout(() => {
					target.removeAttr('disabled');
				}, 300);	

				// force resize
				//let resizeEvent = window.document.createEvent('UIEvents'); 
				//resizeEvent .initUIEvent('resize', true, false, window, 0); 
				//window.dispatchEvent(resizeEvent);
			});
		}
	}

	imageVideoSlider() {
		this.imageVideoContent.slick({
			speed: 200,
			slidesToScroll: 1,
			variableWidth: false,
			dots: true,
			accessibility: true,
			arrows: true,
			focusOnSelect: true,
			rows: 0
		});
	}

	featuredItemSlider() {
		this.featuredItemContent.slick({
			arrows: false,
			dots: true,
			speed: 200,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 993,
					settings: {
						arrows: false,
						dots: true,
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 626,
					settings: {
						arrows: false,
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});

		this.featuredItemContent.show();
	}

	/**
	 * Play button functions
	 */

	getPlayButtonTemplate() {
		return new Promise((resolve, reject) => {
			if (!Util.hasValue(this.templates.playBtn)) {
				return $.get(`/${common.getCultureCode()}/template/play-button`, result => {
					if (!result.IsSuccess) return reject(result.Message);

					this.templates.playBtn = result.Data;
					Mustache.parse(this.templates.playBtn);

					resolve(this.templates.playBtn);
				}).catch(reject);
			} else {
				resolve(this.templates.playBtn);
			}
		})
	}

	appendPlayBtn() {
		let numberOfSlides = this.featuredItemContent.find('.slick-slide:not(.slick-cloned)').length;

		if (numberOfSlides > 1) {
			// load play btn html
			let btnHtml = this.templates.playBtn;
			this.featuredItemContent.find('.slick-dots').append(btnHtml);

			// bind btn
			$('.nha-btn-slider').on('keydown', e => { if (e.which === 13) { e.preventDefault(); $('.slick-slider').slick('slickNext'); } });
			$('.nha-btn-slider').on('click', e => {
				$('.slick-slider').slick('slickNext');
				$('slick-current').find('a').focus();
			});
		}
	}
} 

const components = new Components();

common.on('init', () => components.init());

export default components;



// WEBPACK FOOTER //
// ./wwwroot/js/app/components.js